import Container from "../../../Components/Cards/Account/Container";
import SimpleGray from "../../../Components/Buttons/SimpleGray";
import GradientCustom from "../../../Components/Buttons/GradientCustom";

export default function CardAccount({
  account,
  user,
  accountType,
  isLoading,
  setIsLoading,
}) {
  return (
    <div className="w-full max-w-96 flex flex-col gap-2.5">
      <Container
        color="blue"
        account={account}
        user={user}
        setIsLoading={setIsLoading}
        accountType="live"
      />
      {!isLoading && account && (
        <div className="flex gap-8">
          <GradientCustom
            text="جزئیات حساب"
            color="blue"
            href={`/challenge/account/${account.code}/overview`}
          />
          <div className="w-full">
            <SimpleGray text="معامله" href={`/trade/${account.code}/trade`} />
          </div>
        </div>
      )}
    </div>
  );
}
